import React, { useState } from 'react'
import styled from '@emotion/styled'
import { 
  FormField,
  FormFieldLabelPosition,
  Modal, 
  Switch, 
  useAssistiveHideSiblings, 
  useDisableBodyScroll, 
  useFocusTrap, 
  useInitialFocus, 
  useModalModel, 
  useReturnFocus 
} from "@workday/canvas-kit-react"

import { 
  featureFlags, 
  featureFlagDescriptions, 
  getFlagsFromLocalStorage, 
  LOCAL_STORAGE_KEY 
} from '../utils/FeatureFlagFramework'

export interface FeatureFlagManagerProps {
  onHide: () => void
}
const StyledFormField = styled(FormField)`
  > label {
   width:100%;
  }
`
export const FeatureFlagManager = (props: FeatureFlagManagerProps) => {
  const [currlStorage, setCurrLStorage] = useState({
    ...getFlagsFromLocalStorage(),
    ...featureFlags,
  })
  const model = useModalModel({
    onHide: () => {
      props.onHide()
      window.location.href = window.location.href
    }
  })
  useInitialFocus(model)
  useReturnFocus(model)
  useFocusTrap(model)
  useAssistiveHideSiblings(model)
  useDisableBodyScroll(model)
  model.state.visibility = 'visible'
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target
    const copy = {
      ...currlStorage,
      [name]: checked,
    }
    setCurrLStorage(copy)
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(copy))
  }
  
  return (
    <Modal model={model}>
      <Modal.Overlay>
        <Modal.Card>
          <Modal.CloseIcon aria-label="Close" />
          <Modal.Heading>Feature Flag Manager</Modal.Heading>
          <Modal.Body>
            {
              Object.entries(featureFlagDescriptions).map(([key, desc]) => {
                return (
                <StyledFormField grow={true} key={key} label={desc} labelPosition={FormFieldLabelPosition.Left}>
                  <Switch
                    name={key}
                    checked={currlStorage[key] || false}
                    onChange={onChange}
                  />
                </StyledFormField>
                )
              })
            }
          </Modal.Body>
        </Modal.Card>
      </Modal.Overlay>
    </Modal>
  )
}
export default FeatureFlagManager